import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { ArrowBackHoc } from '../../../assets/images';
import { BlockedIcon, chat as ChatIcon, InfoIcon, InformationIcon, LogoutIcon, NextArrow, NotificationIcon, StarredMessage, Archived, IconcontactUs, IconDelete } from './images';
import { blockOfflineAction, getLocalWebsettings, setLocalWebsettings } from '../../../Helpers/Utility';
import { getFromLocalStorageAndDecrypt, encryptAndStoreInLocalStorage } from '../../../Helpers/Chat/webChatEncryptDecrypt';

const imageComponent = {
    chat: ChatIcon,
    Archived: Archived,
    notification: NotificationIcon,
    blocked: BlockedIcon,
    about: InfoIcon,
    policy: InformationIcon,
    logout: LogoutIcon,
    star: StarredMessage,
    delete: IconDelete,
    contactUs :IconcontactUs,
};

export const SettingCheckBox = (props = {}) => {
    const { id, label, getaAtion, chat = false, children, dafaultSetting } = props;
    const [activeSettings, setSettings] = React.useState(dafaultSetting || false);

    React.useEffect(()=>{
        setSettings(dafaultSetting || false)
    },[props])

    const chatSetting = (event) => {
        if (blockOfflineAction()) return;
        setSettings(!activeSettings);
        getaAtion(!activeSettings);
    };

    const settingListener = (event) => {
        const { checked, name } = event.target;
        if (Notification.permission === 'denied' || Notification.permission === 'default') {
            setSettings(false);
            toast.error(ENABLE_NOTIFICATIONS, {
                toastId: 'Notification',
            })
        }
        else {
            setSettings(checked)
            const webSettings = getFromLocalStorageAndDecrypt('websettings')
            let parserLocalStorage = webSettings ? JSON.parse(webSettings) : {}
            const constructObject = {
                ...parserLocalStorage,
                [name]: checked
            }
            encryptAndStoreInLocalStorage('websettings', JSON.stringify(constructObject));
        }
    }

    useEffect(() => {
        if (!chat) {
            if (Notification.permission === 'denied' || Notification.permission === 'default') {
                setSettings(false);
            }
            else {
                const webSettings = getFromLocalStorageAndDecrypt('websettings');
                const settings = getLocalWebsettings();
                if (settings.Notifications === undefined) {
                    setLocalWebsettings("Notifications", true);
                    setSettings(true);
                } else {
                    let parserLocalStorage = JSON.parse(webSettings);
                    const { [id]: status = false } = parserLocalStorage;
                    setSettings(status);
                }
            }
        }
    }, []);

    return (

        <li className="setting-list">
            <label className="setting-option">
                <div className="checkbox">
                    <input
                        name={id}
                        type="checkbox"
                        checked={chat ? dafaultSetting : activeSettings}
                        id={id}
                        onChange={chat ? chatSetting : settingListener}
                        className={!activeSettings ? "disabled" : ""}
                    />
                    <label htmlFor={id}></label>
                </div>
                <div className="label">
                    <span className="label-text">{label}</span>
                </div>
            </label>
            {children}
        </li>
    )
};


export const SettingOptions = (props = {}) => {
    const { handleOptions, label, image, enableRightArrow = true,children } = props
    const { [image]: Icon } = imageComponent
    return (
        <li className="setting-list" onClick={() => handleOptions(image)}>
            <div className="setting-option">
                {Icon && <i className="iconLeft"><Icon viewBox="0 0 18.2 17.384"/></i>}
                <span className="Option-text">{label}</span>
                {enableRightArrow && <i className="iconNext"><NextArrow viewBox="0 0 6 10"/></i>}
            </div>
            {children}
        </li>
    )
};

export const SettingsHeader = (props) => {
    const { handleBackFromSetting, label } = props
    return (
        <div className="setting-header">
            <div className="setting-header-text">
                <i onClick={handleBackFromSetting} className="newchat-icon" title="Back">
                    <ArrowBackHoc viewBox="0 0 24 24"/>
                </i>
                <span>{label}</span>
            </div>
        </div>
    )
};
